"use strict";

module.exports = require("./BaseStringHandler");